import { Outlet, useLocation } from 'react-router';
import { Header } from '@dynamon-as/ui';
import { NavigationGuardProvider } from '@contexts';
import { HeaderActions, HeaderBreadcrumbs, OrgLogo } from '@layouts/components';
import { cx } from '@lib/utils';
import { ORGANIZATION_PATHS } from '@pages/organization/config';
import styles from './HeaderOnlyLayout.module.css';
import type { FC } from 'react';

const PLAIN_CONTENT_PATHS = [ORGANIZATION_PATHS.settings] as const;

const usesPlainContent = (pathname: string): boolean =>
    PLAIN_CONTENT_PATHS.some((path) => pathname.startsWith(path));

const HeaderOnlyLayoutContent: FC = () => {
    const { pathname } = useLocation();

    return (
        <div className={styles.container}>
            <Header
                logo={<OrgLogo />}
                actions={<HeaderActions />}
                breadcrumb={<HeaderBreadcrumbs />}
            />
            <main
                className={cx(
                    styles.content,
                    usesPlainContent(pathname) && styles.contentPlain,
                )}
            >
                <Outlet />
            </main>
        </div>
    );
};

const HeaderOnlyLayout: FC = () => (
    <NavigationGuardProvider>
        <HeaderOnlyLayoutContent />
    </NavigationGuardProvider>
);

export default HeaderOnlyLayout;
